import React, {Suspense, lazy, useEffect} from 'react';

import {Routes, Route} from 'react-router-dom';
import {
  CircularProgress,
  useMediaQuery,
  // Typography,
  // Grid,
  // Link
} from '@mui/material';

// Kept as a static import: it's the landing route and drives the LCP,
// so it must not wait on an extra chunk fetch.
import Home from './Home/Home';
import {useContentStore} from '../stores/useContentStore';
import CustomAppBar from '../components/AppBar/AppBar';
import Footer from '../components/Footer/Footer';
// import BuildUp from './BuildUp/BuildUp';

import * as RoutesNames from '../constants/routes';

import './app.scss';

const TravelCakes = lazy(() => import('./TravelCakes/TravelCakes'));
const Macarons = lazy(() => import('./Macarons/Macarons'));
const Tortas = lazy(() => import('./Tortas/Tortas'));
const TartasClasicas = lazy(() => import('./TartasClasicas/TartasClasicas'));
const TartasVitrina = lazy(() => import('./TartasVitrina/TartasVitrina'));
const Cookies = lazy(() => import('./Cookies/Cookies'));
const TermsAndConditions =
  lazy(() => import('./TermsAndConditions/TermsAndConditions'));

const RouteFallback = () => (
  <CircularProgress
    color="secondary"
    sx={{display: 'block', margin: '80px auto'}}
  />
);

const App = () => {
  const matches = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const fullScreen = useMediaQuery((theme) => theme.breakpoints.up('xl'));
  const fetchAllPages = useContentStore((state) => state.fetchAllPages);

  useEffect(() => {
    fetchAllPages();
  }, []);

  return (
    <div className="app">
      <CustomAppBar matches={matches} fullScreen={fullScreen} />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route
            path={RoutesNames.HOME}
            element={
              <Home
                matches={matches}
                fullScreen={fullScreen}
              />
            }
          />
          <Route
            path={RoutesNames.MACARONS}
            element={<Macarons matches={matches} fullScreen={fullScreen} />}
          />
          <Route
            path={RoutesNames.COOKIES}
            element={<Cookies matches={matches} fullScreen={fullScreen} />}
          />
          <Route
            path={RoutesNames.TARTAS_CLASICAS}
            element={
              <TartasClasicas matches={matches} fullScreen={fullScreen} />
            }
          />
          <Route
            path={RoutesNames.TORTAS_VITRINA}
            element={
              <TartasVitrina matches={matches} fullScreen={fullScreen} />
            }
          />
          <Route
            path={RoutesNames.TRAVEL_CAKES}
            element={<TravelCakes matches={matches} fullScreen={fullScreen} />}
          />
          <Route
            path={RoutesNames.TORTAS}
            element={<Tortas matches={matches} fullScreen={fullScreen} />}
          />
          <Route
            path={RoutesNames.TERMS_AND_CONDITIONS}
            element={
              <TermsAndConditions
                matches={matches}
                fullScreen={fullScreen}
              />
            }
          />
        </Routes>
      </Suspense>
      <Footer matches={matches} fullScreen={fullScreen} />
      {/* <Grid
        style={{
          backgroundColor: '#4B4B4B',
          paddingTop: '10px',
          paddingBottom: '10px',
        }}
      >
        <Typography color="#FAFAFA" variant="subtitle2">
          Pagina web desarrollada por <Link color="#FAFAFA" href="https://www.linkedin.com/in/juanbergues/" underline="hover" variant="subtitle2">
            Juan Bergues
          </Link> 👨‍💻
        </Typography>
      </Grid> */}
    </div >
  );
};

export default App;
